export default "__VITE_ASSET__CzRKBp8u__"